import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetSupplierProductSlice = createSlice({
    name: "getSupplierProducts",
    initialState,
    reducers: {
        getSupplierProductsRequest(state) {
            state.loading = true;
        },
        getSupplierProductsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getSupplierProductsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getSupplierProductsRequest,
    getSupplierProductsRequestSuccess,
    getSupplierProductsRequestError,
} = GetSupplierProductSlice.actions;

export default GetSupplierProductSlice.reducer;
